import Lottie from "react-lottie";
import notFoundAnimation from "../animations/notfound.json";
import { Link } from "react-router-dom";
import { Page, ui } from "../components/ui";

const style = {
  container: {
    padding: "3rem 0",
    textAlign: "center",
    display: "flex",
    flexDirection: " column",
    justifyContent: "center",
    alignItems: "center",
  },
};

function NotFound() {
  return (
    <Page maxWidth="none">
      <div style={style.container}>
        <h1 style={ui.pageTitle}>Page not found</h1>
        <p style={ui.muted}>That page is nowhere to be found.</p>
        <p>
          <Link to="/">Go to homepage</Link>
        </p>
        <Lottie
          options={{
            loop: true,
            autoplay: true,
            animationData: notFoundAnimation,
          }}
          height={600}
        />
      </div>
    </Page>
  );
}

export default NotFound;
